module.exports = __webpack_public_path__ + "static/media/details-4.7569a316.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/details-4.jpeg
// module id = 72
// module chunks = 0